import type { ReactNode } from "react";
import { motion } from "framer-motion";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeader from "@/components/SectionHeader";

const faqs: { question: string; answer: ReactNode }[] = [
  {
    question: "Welche Betonmengen kann ich abholen?",
    answer: "Ab 0,15 m³ bis zu mehreren Kubikmetern. Die genaue Menge wählen Sie direkt am Terminal.",
  },
  {
    question: "Welche Zahlungsmethoden werden akzeptiert?",
    answer:
      "Privatkunden zahlen per EC-Karte oder Kreditkarte. Gewerbekunden können sich ein Kundenkonto anlegen lassen und erhalten einen NFC-Chip zur Zahlung per Rechnung. Abrechnung auch über Partner-Baustoffhändler möglich (hierzu bitte telefonisch an uns wenden).",
  },
  {
    question: "Brauche ich ein spezielles Fahrzeug?",
    answer: "Ein Anhänger oder ein Fahrzeug mit passender Ladefläche genügt. Für größere Mengen empfehlen wir einen Kipper-Anhänger.",
  },
  {
    question: "Wie sind die Öffnungszeiten?",
    answer: (
      <>
        Montag bis Samstag von 06:00 bis 20:00 Uhr. Sonntags sowie an Feiertagen bleibt die Station geschlossen.
        Folgen Sie uns auf unseren Social-Media-Kanälen, um keine aktuellen Infos zu verpassen:{" "}
        <a
          href="https://instagram.com/beton2go_romano"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline-offset-4 hover:underline"
        >
          Instagram @beton2go_romano
        </a>{" "}
        ·{" "}
        <a
          href="https://facebook.com/beton2goromano"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline-offset-4 hover:underline"
        >
          Facebook Beton2go Romano
        </a>
        .
      </>
    ),
  },
  {
    question: "Muss ich den Beton vorbestellen?",
    answer: "Nein. Sie können in der Regel direkt vorbeikommen und den Beton vor Ort auswählen.",
  },
  {
    question: "Was passiert bei einer Fehlkalkulation?",
    answer: "Bereits ausgegebener Beton kann nicht zurückgenommen werden. Bei Unsicherheit bitte vorher erkundigen.",
  },
];

const FAQSection = () => {
  return (
    <section className="section-shell overflow-hidden">
      <div id="faq" className="container mx-auto px-4 scroll-mt-20 md:scroll-mt-24">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeader
              eyebrow="FAQ"
              title={
                <>
                  Die wichtigsten Fragen,
                  <br />
                  knapp beantwortet.
                </>
              }
              description="Die Seite soll schnell Orientierung geben. Deshalb sind die Antworten bewusst direkt gehalten."
            />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.55 }}
            className="surface-panel p-2 md:p-3"
          >
            <Accordion type="single" collapsible className="divide-y divide-white/10">
              {faqs.map((faq, index) => (
                <AccordionItem key={faq.question} value={`faq-${index}`} className="border-none px-4 md:px-6">
                  <AccordionTrigger className="py-6 text-left font-display text-lg uppercase tracking-[0.06em] text-foreground transition-colors hover:text-primary hover:no-underline md:text-xl">
                    <span className="flex items-center gap-4">
                      <span className="info-label text-primary/90">{String(index + 1).padStart(2, "0")}</span>
                      <span>{faq.question}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-[4.4rem] pr-2 text-sm leading-relaxed text-muted-foreground md:text-base">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
